module.exports = __webpack_public_path__ + "img/correct-extract-icon.9f5897b1.png";